var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcoResponsibleGaming = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 16.002,
    viewBox: "0 0 18 16.002",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ico_responisble_gaming",
    transform: "translate(-289.021 -61.78)",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_652-2",
    "data-name": "Ellipse 652-2",
    cx: 3.395,
    cy: 3.545,
    rx: 3.395,
    ry: 3.545,
    transform: "translate(292.329 61.78)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48669-2",
    "data-name": "Path 48669-2",
    d: "M297.152,72.917a5.414,5.414,0,0,1,1.169-3.365.982.982,0,0,0-.521.2,3.287,3.287,0,0,1-4.223-.02.929.929,0,0,0-.81-.189,6.178,6.178,0,0,0-3.736,5.34c-.092.833.346,2.864,6.623,2.894a16.734,16.734,0,0,0,3.892-.361A5.442,5.442,0,0,1,297.152,72.917Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48684",
    "data-name": "Path 48684",
    d: "M302.6,68.668a4.247,4.247,0,0,0-.01,8.494h.01a4.247,4.247,0,0,0,0-8.494Zm1.959,4.8h-3.98a.554.554,0,1,1,0-1.108h3.98a.554.554,0,1,1,0,1.108Z",
    transform: "translate(.176)"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcoResponsibleGaming);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ico_responsible_gaming.707c08901a74284c53b24fb0e3d1b63c.svg";